import language from '../locals';

/*
* 判断设备 是安卓还是IOS还是其他**/
let u = navigator.userAgent;
let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
let device = isAndroid ? 'Android' : (isiOS ? 'IOS' : 'Other');

/* 设置LocalStorage */
export function setLocalStorage(key, val) {
  if (typeof (val) == 'string' || !isNaN(val)) {
    localStorage.setItem(key, val);
  } else {
    localStorage.setItem(key, JSON.stringify(val));
  }
}

/* 取值LocalStorage */
export function getLocalStorage(key) {
  let u = navigator.userAgent;
  if (window.jsInterface || (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.goToPage)) {
    let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
    let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    if (isAndroid && window.jsInterface) {
      const res = window.jsInterface.getBasicInfo();
      const baseInfoObj = JSON.parse(res || '{}');
      if (key === 'LOGINMESSAGE') {
        // console.log(222,JSON.parse(baseInfoObj.accountInfo|| '{}'))
        // console.log(222,typeof JSON.parse(baseInfoObj.accountInfo|| '{}'))
        return JSON.parse(baseInfoObj.accountInfo || '{}')
      } else if (key === "USERID") {
        // console.log(333,baseInfoObj.userId)
        // console.log(333,typeof  baseInfoObj.userId)
        return baseInfoObj.userId
      } else {
        try {
          JSON.parse(localStorage.getItem(key));
          return JSON.parse(localStorage.getItem(key));
        } catch (e) {
          return localStorage.getItem(key);
        }
      }

    } else if (isiOS) {
      const res = window.prompt("getBasicInfo");
      const baseInfoObj = JSON.parse(res || '{}');
      if (key === 'LOGINMESSAGE') {
        return JSON.parse(baseInfoObj.accountInfo || '{}')
      } else if (key === "USERID") {
        return baseInfoObj.userId
      } else {
        try {
          JSON.parse(localStorage.getItem(key));
          return JSON.parse(localStorage.getItem(key));
        } catch (e) {
          return localStorage.getItem(key);
        }
      }
    }
  } else {
    try {
      JSON.parse(localStorage.getItem(key));
      return JSON.parse(localStorage.getItem(key));
    } catch (e) {
      return localStorage.getItem(key);
    }
  }
  // try {
  //   JSON.parse(localStorage.getItem(key));
  //   return  JSON.parse(localStorage.getItem(key));
  // } catch(e) {
  //   return localStorage.getItem(key);
  // }
}

export function Navigator() {
  var ua = navigator.userAgent.toLowerCase();//获取判断用的对象
  if (ua.match(/MicroMessenger/i) == "micromessenger") {
    //在微信中打开
    return true;
  }
  if (ua.match(/WeiBo/i) == "weibo") {
    //在新浪微博客户端打开
    return true;
  }
  if (ua.match(/QQ/i) == "qq") {
    //在QQ打开
    return true;
  }
  return false;
}

/* 公共的用户信息 */
export function userInfo() {
  let u = navigator.userAgent;
  let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
  let isiOS = u.indexOf('iPhone') > -1;
  if (isAndroid && window.jsInterface) {
    const res = window.jsInterface.getBasicInfo();
    const { token } = JSON.parse(res || '{}');
    return token;
  } else if (isiOS) {
    // const res = window.prompt("getBasicInfo");
    // const {token} = JSON.parse( res||'{}');

    // return '0898b6eb2ab1ba0f21185990ceb8a23e|2f7aa398bcc94bb1ce208091acc98dad'

    if (window.webkit && window.webkit.messageHandlers) {

      if (Navigator()) {
        return;
      }
      // if(window.getPlatform){
      //
      // }
      const res = window.prompt("getBasicInfo");
      const { token } = JSON.parse(res || '{}');
      // alert('获取token' + token)
      return token;
    }
  }

}

/* 清除登录信息 */
export function clearLoginMessage() {
  clearLocalStorage('USERID');
  clearLocalStorage('ISHASTXPASSWORD');
  clearLocalStorage('ISHASPASSWORD')
  clearLocalStorage('LOGINMESSAGE');
  clearLocalStorage('APPDATA');
}

/* 清除LocalStorage */
export function clearLocalStorage(key) {
  localStorage.removeItem(key)
}


// 返回
export function goBack() {
  if (process.env.NODE_ENV === 'development') {
    window.history.go(-1);
    return


  }


  // debugger
  let u = navigator.userAgent;
  let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
  let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
  if (isAndroid) {
    window.jsInterface.goBack();

  } else if (isiOS) {
    window.webkit.messageHandlers.goBack.postMessage({ "body": "goBack" });
  } else {
    window.history.go(-1);

  }
}

// 返回首页
export function goToHome() {
  let u = navigator.userAgent;
  let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
  let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
  if (window.jsInterface || (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.goToPage)) {
    if (isAndroid) {
      window.jsInterface.goToPage('PAGE_HOME', '')
    } else if (isiOS) {
      window.webkit.messageHandlers.goToPage.postMessage({
        "body": "PAGE_HOME"
      });
    }
  }
}

// export function openPdf(url) {
//   let u = navigator.userAgent;
//   let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
//   let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
//   if (isAndroid) {
//     PageNavigator.startActivity('PAGE_PDF', { pdfUrl: url, title: '' });
//   } else if (isiOS) {
//     window.webkit.messageHandlers.goBack.postMessage({ "body": "goBack" });
//   }
// }

// 将base64 获取 文件 
export function getFile(dataurl) {
  if (!dataurl) return
  var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], 'liveface.png', { type: mime });
}

// 退出登录并返回首页
export function logoutToHome() {
  let u = navigator.userAgent;
  let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
  let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
  if (window.jsInterface || (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.goToPage)) {
    if (isAndroid) {
      window.jsInterface.loginOutAndToHomePage();
    } else if (isiOS) {
      window.webkit.messageHandlers.loginOutAndToHomePage.postMessage({
        "body": ""
      });
    }

  }
}

// 通用获取状态栏高度方法
export function getStatusBarHeight() {
  let u = navigator.userAgent;
  let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
  let isiOS = u.indexOf('iPhone') > -1;
  let getStatusBarHeight = 0
  if (isAndroid && window.jsInterface) {
    getStatusBarHeight = window.jsInterface.getStatusBarHeight();
    // console.log('getStatusBarHeight', getStatusBarHeight);
    return getStatusBarHeight
  } else if (isiOS) {

    if (window.webkit && window.webkit.messageHandlers) {
      getStatusBarHeight = window.prompt("getStatusBarHeight");
      return getStatusBarHeight
    }
  }
  return getStatusBarHeight
}

// 获取配置文件
export function getCloudConfig() {
  let u = navigator.userAgent;
  let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
  let isiOS = u.indexOf('iPhone') > -1;
  if (isAndroid) {
    let getCloudConfig = window.Android.getCloudConfig();

    return JSON.parse(getCloudConfig)
  } else if (isiOS) {

    if (window.webkit && window.webkit.messageHandlers) {
      let getCloudConfig = window.prompt("getCloudConfig");
      return JSON.parse(getCloudConfig)
    }
    // return JSON.parse('{}')
  }
}


// 获取语言
export function getLanguage() {

  let u = navigator.userAgent;
  let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
  let isiOS = u.indexOf('iPhone') > -1;
  if (isAndroid && window.jsInterface) {
    const res = window.jsInterface.getBasicInfo();
    const { language } = JSON.parse(res || '{}');

    // console.log('当前语言', language);
    return language;
  } else if (isiOS) {
    if (window.webkit && window.webkit.messageHandlers) {
      if (Navigator()) {
        return;
      }
      const res = window.prompt("getBasicInfo");
      const { language } = JSON.parse(res || '{}');
      return language;
    }
  }
}

// 获取皮肤
export function getTheme() {

  let u = navigator.userAgent;
  let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
  let isiOS = u.indexOf('iPhone') > -1;
  if (isAndroid && window.jsInterface) {
    const theme = window.jsInterface.getTheme ? window.jsInterface.getTheme() : 'BLACK';

    console.log('当前主题', theme);
    return theme;
  } else if (isiOS) {
    if (window.webkit && window.webkit.messageHandlers) {
      const theme = window.prompt("getTheme") ? window.prompt("getTheme") : 'BLACK';
      return theme;
    }
  }
}

/*
 * js浮点数计算的问题 */
export function digitalCalculation(arg1, arg2, type = 'multiply') {
  if (type === 'multiply') {
    let m = 0, s1 = arg1.toString(),
      s2 = arg2.toString();
    try {
      m += s1.split(".")[1].length
    } catch (e) { }
    try {
      m += s2.split(".")[1].length
    } catch (e) { }
    return Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m)
  } else if (type === 'division') {
    let c, d, e = 0,
      f = 0;
    try {
      e = arg1.toString().split(".")[1].length;
    } catch (g) { }
    try {
      f = arg2.toString().split(".")[1].length;
    } catch (g) { }
    c = Number(arg1.toString().replace(".", ""));
    d = Number(arg2.toString().replace(".", ""));
    return (c / d * Math.pow(10, f - e));
  } else if (type === 'add') {
    var r1, r2, m;
    try { r1 = arg1.toString().split(".")[1].length } catch (e) { r1 = 0 }
    try { r2 = arg2.toString().split(".")[1].length } catch (e) { r2 = 0 }
    m = Math.pow(10, Math.max(r1, r2));
    return (arg1 * m + arg2 * m) / m
  }
}

/* 向下取整保留两位小数 */
export function number2Floor(number) {
  let num = Math.abs(number);
  num = Math.floor(digitalCalculation(num || 0, 100));
  let Floor2Number;
  if (number < 0) {
    Floor2Number = '-' + digitalCalculation(num, 100, 'division').toFixed(2);
  } else {
    Floor2Number = digitalCalculation(num, 100, 'division').toFixed(2)
  }
  return Floor2Number
}

/**
 * 计算时间间隔
*/
export function culIntervalTime(time) {
  var start = new Date(time); //开始的时间
  console.log('shijian', start);
  var end = Date.parse(new Date()); //结束的时间
  var se = end - start; //计算两个时间之间的秒数
  var hour = Math.floor(se / (3600 * 1000)); // 计算天数
  var min = Math.floor(se / (60 * 1000)); // 计算天数
  var days = Math.floor(se / (24 * 3600 * 1000)); // 计算天数
  console.log(days, hour, min, se);   //30
  if (days > 0) {
    return days + language['news.days.ago']
  }
  if (hour > 0) {
    return hour + language['news.hours.ago']
  }
  if (min > 0) {
    return min + language['news.minutes.ago']
  }
  return se + language['news.seconds.ago']
}

export function getBasicInfo() {
  let u = navigator.userAgent;
  let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
  let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
  if (isAndroid) {
    const res = JSON.parse(window.jsInterface.getBasicInfo());
    return res;

  } else if (isiOS) {
    const res = JSON.parse(window.prompt("getBasicInfo") || '{}');
    return res;
  } else {
    return {}
  }
}

/*
* 跳转至行情*/
export function goToQuotes(stockCode, stockName, market) {
  if (device == 'Android' && window.jsInterface) {  //安卓设备
    window.jsInterface.goToPage('PAGE_OPEN_QUOTATION', JSON.stringify({ stockCode: stockCode, stockName: stockName, market: market }));
  } else if (device == 'IOS' && window.webkit && window.webkit.messageHandlers) {  //IOS设备
    window.webkit.messageHandlers.goToPage.postMessage({ "body": "PAGE_OPEN_QUOTATION", "stockCode": stockCode, "stockName": stockName, 'market': market });
  } else {  //其他设备
    console.error('当前不是app')
  }
}


